(function () {
  'use strict';

  // === Config ===
  var API_URL = 'https://eureka.api.useinsider.com/api/web/collections/Category';
  var AUTH_TOKEN = 'INS.wFA5_Ecx5sob-w6zk1Tn.hTjA6XV8rGJqLNvYa09q4Gz403nTVFfDTC2+gm_57w91oj4C-D';
  var PARTNER_ID = '10002548';
  var PAGE_SIZE = 30;

  // Eureka aktif olacak collection handle'lari ve karsilik gelen cf degerleri
  var EUREKA_COLLECTIONS = {
    'womens-bottoms': "Women's Bottoms",
    'sneakers': "Sneakers",
    'health-beauty': "Health & Beauty",
  };

  // === DOM ===
  var container = document.querySelector('[data-eureka-category]');
  if (!container) return;

  var handle = container.getAttribute('data-collection-handle') || '';
  var categoryFilter = EUREKA_COLLECTIONS[handle];

  // Bu collection Eureka listesinde degilse hicbir sey yapma
  if (!categoryFilter) return;

  var currency = container.getAttribute('data-currency') || 'USD';
  var locale = 'en_US';
  // Tag'i URL'den parse et
  var pathParts = window.location.pathname.replace(/\/$/, '').split('/');
  var currentTag = '';
  if (pathParts.length > 3) {
    var sortTagsSelect = document.getElementById('SortTags');
    if (sortTagsSelect && sortTagsSelect.selectedIndex > 0) {
      currentTag = sortTagsSelect.options[sortTagsSelect.selectedIndex].text;
    }
  }
  var viewText = container.getAttribute('data-view-text') || 'View';
  var saleText = container.getAttribute('data-sale-text') || 'Sale';
  var vendorEnable = container.getAttribute('data-vendor-enable') === 'true';
  var fallbackGrid = container.querySelector('[data-eureka-fallback]');
  var loader = container.querySelector('[data-eureka-loader]');

  if (!fallbackGrid) return;

  // Fallback'i goster, loader'i gizle
  function showFallback() {
    if (loader) loader.style.display = 'none';
    fallbackGrid.style.display = '';
  }
  function hideLoader() {
    if (loader) loader.style.display = 'none';
  }

  // === Sayfa numarasini URL'den al ===
  var urlParams = new URLSearchParams(window.location.search);
  var currentPage = parseInt(urlParams.get('page'), 10) || 1;
  var currentSort = urlParams.get('sort') || '';

  // === Filtre ===
  var attrFilter = currentTag ? 'shopify_tag~' + currentTag : '';

  // === API fonksiyonu ===
  function fetchEureka(sortType, page) {
    var offset = (page - 1) * PAGE_SIZE;
    var query = 'p=' + PARTNER_ID +
      '&l=' + encodeURIComponent(locale) +
      '&c=' + encodeURIComponent(currency) +
      '&ps=' + PAGE_SIZE +
      '&pf=' + offset +
      '&cf=' + encodeURIComponent(categoryFilter) +
      '&st=' + encodeURIComponent(sortType) +
      '&a=' + encodeURIComponent(attrFilter);

    return fetch(API_URL + '?' + query, {
      headers: { 'X-Auth-Token': AUTH_TOKEN }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      });
  }

  // === Ilk yukleme ===
  fetchEureka(currentSort, currentPage)
    .then(function (json) {
      if (json.status !== 'Success' || !json.data || !json.data.items) {
        throw new Error('Invalid response');
      }
      var items = json.data.items;
      if (!items.length) {
        showFallback();
        return;
      }

      var totalItems = (json.data.navigation && json.data.navigation.totalItems) || items.length;
      var sortings = json.data.sortings || [];

      hideLoader();
      fallbackGrid.style.display = '';
      renderProducts(items, totalItems);
      replaceSortDropdown(sortings);
    })
    .catch(function (err) {
      console.warn('[Eureka] API failed, Shopify fallback active:', err);
      showFallback();
    });

  // === Sort dropdown'unu Eureka secenekleriyle degistir ===
  function replaceSortDropdown(sortings) {
    var sortBySelect = document.getElementById('SortBy');
    if (!sortBySelect || !sortings.length) return;

    // Mevcut optionlari temizle
    sortBySelect.innerHTML = '';

    // Eureka sorting seceneklerini ekle
    sortings.forEach(function (s) {
      var option = document.createElement('option');
      option.value = s.type;
      option.textContent = s.label;
      if (s.selected || s.type === currentSort) {
        option.selected = true;
      }
      sortBySelect.appendChild(option);
    });

    // Label'i guncelle
    var label = sortBySelect.previousElementSibling || sortBySelect.parentElement.querySelector('label[for="SortBy"]');
    if (label) label.textContent = 'Sort by';

    // Mevcut Shopify change handler'ini kaldir ve Eureka handler'ini ekle
    var newSelect = sortBySelect.cloneNode(true);
    sortBySelect.parentNode.replaceChild(newSelect, sortBySelect);

    newSelect.addEventListener('change', function () {
      var selectedSort = newSelect.value;

      // URL'i guncelle (sayfa yenilemeden)
      var params = new URLSearchParams(window.location.search);
      params.set('sort', selectedSort);
      params.delete('page');
      var newUrl = window.location.pathname + '?' + params.toString();
      window.history.replaceState(null, '', newUrl);

      // Eureka'dan yeni siralama ile cek
      currentPage = 1;
      fetchEureka(selectedSort, 1)
        .then(function (json) {
          if (json.status !== 'Success' || !json.data || !json.data.items) return;
          var items = json.data.items;
          if (!items.length) return;
          var totalItems = (json.data.navigation && json.data.navigation.totalItems) || items.length;
          renderProducts(items, totalItems);

          // Dropdown'daki selected durumunu guncelle
          var sortings = json.data.sortings || [];
          sortings.forEach(function (s, idx) {
            if (newSelect.options[idx]) {
              newSelect.options[idx].selected = (s.type === selectedSort);
            }
          });

          // Sayfanin ustune scroll
          container.scrollIntoView({ behavior: 'smooth', block: 'start' });
        })
        .catch(function (err) {
          console.warn('[Eureka] Sort failed:', err);
        });
    });
  }

  // === Render ===
  function renderProducts(items, totalItems) {
    var html = '';
    items.forEach(function (item) {
      var card = item.itemProperties && item.itemProperties.item_card;
      if (!card) return;
      html += buildCardHTML(card);
    });

    if (!html) return;

    html += '<div class="grid__item" style="width:100%;text-align:right;padding:8px 0;">' +
      '<span style="font-size:11px;color:#999;">Powered by Eureka</span></div>';

    fallbackGrid.innerHTML = html;

    // Pagination
    var totalPages = Math.ceil(totalItems / PAGE_SIZE);
    var pageWidth = container.closest('.page-width');
    if (pageWidth) {
      var existingPagination = pageWidth.querySelector('.pagination');
      if (totalPages > 1) {
        var paginationHTML = buildPaginationHTML(currentPage, totalPages);
        if (existingPagination) {
          existingPagination.innerHTML = paginationHTML;
        } else {
          var paginationDiv = document.createElement('div');
          paginationDiv.className = 'pagination';
          paginationDiv.innerHTML = paginationHTML;
          container.parentNode.insertBefore(paginationDiv, container.nextSibling);
        }
      } else if (existingPagination) {
        existingPagination.style.display = 'none';
      }
    }

    if (window.lazySizes && lazySizes.autoSizer) {
      lazySizes.autoSizer.checkElems();
    }
  }

  // === Pagination HTML ===
  function buildPaginationHTML(current, total) {
    var basePath = window.location.pathname;
    var params = new URLSearchParams(window.location.search);
    var html = '';

    if (current > 1) {
      params.set('page', current - 1);
      if (current - 1 === 1) params.delete('page');
      html += '<span class="prev"><a href="' + basePath + (params.toString() ? '?' + params.toString() : '') + '">&larr;</a></span> ';
    }

    var start = Math.max(1, current - 3);
    var end = Math.min(total, current + 3);

    if (start > 1) {
      params.delete('page');
      html += '<span class="page"><a href="' + basePath + (params.toString() ? '?' + params.toString() : '') + '">1</a></span> ';
      if (start > 2) html += '<span class="deco">&hellip;</span> ';
    }

    for (var i = start; i <= end; i++) {
      if (i === current) {
        html += '<span class="page current">' + i + '</span> ';
      } else {
        if (i === 1) {
          params.delete('page');
        } else {
          params.set('page', i);
        }
        html += '<span class="page"><a href="' + basePath + (params.toString() ? '?' + params.toString() : '') + '">' + i + '</a></span> ';
      }
    }

    if (end < total) {
      if (end < total - 1) html += '<span class="deco">&hellip;</span> ';
      params.set('page', total);
      html += '<span class="page"><a href="' + basePath + '?' + params.toString() + '">' + total + '</a></span> ';
    }

    if (current < total) {
      params.set('page', current + 1);
      html += '<span class="next"><a href="' + basePath + '?' + params.toString() + '">&rarr;</a></span>';
    }

    return html;
  }

  // === Card HTML ===
  function buildCardHTML(card) {
    var price = extractPrice(card.price, currency);
    var originalPrice = extractPrice(card.original_price, currency);
    var discount = extractPrice(card.discount, currency);
    var hasDiscount = discount > 0 && originalPrice > price;
    var inStock = card.in_stock === 1;
    var brand = card.brand && card.brand !== '-' ? card.brand : '';
    var viewBtnClass = 'btn product-card__overlay-btn' +
      (viewText.length > 8 ? ' btn--narrow' : '');

    return '<div class="grid__item small--one-half medium-up--one-fifth">' +
      '<a href="' + escapeAttr(card.url) + '" class="product-card">' +
        '<div class="product-card__image-container">' +
          '<div class="product-card__image-wrapper">' +
            '<div class="product-card__image product-card__image--eureka js" style="max-width:235px;" data-image-with-placeholder-wrapper>' +
                '<img class="lazyload"' +
                  ' data-src="' + escapeAttr(card.image_url) + '"' +
                  ' data-sizes="auto"' +
                  ' data-parent-fit="contain"' +
                  ' data-image' +
                  ' alt="' + escapeAttr(card.name) + '">' +
              '<div class="placeholder-background placeholder-background--animation" data-image-placeholder></div>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="product-card__info">' +
          (vendorEnable && brand
            ? '<div class="product-card__brand">' + escapeHTML(brand) + '</div>'
            : '') +
          '<div class="product-card__name">' + escapeHTML(card.name) + '</div>' +
          (inStock
            ? '<div class="product-card__price">' +
                (hasDiscount
                  ? '<s class="product-card__regular-price">' + formatPrice(originalPrice) + '</s> ' +
                    formatPrice(price)
                  : formatPrice(price)) +
              '</div>'
            : '<div class="product-card__availability">Sold Out</div>') +
        '</div>' +
        (hasDiscount
          ? '<div class="product-tag product-tag--absolute" aria-hidden="true">' + escapeHTML(saleText) + '</div>'
          : '') +
        '<div class="product-card__overlay">' +
          '<span class="' + viewBtnClass + '">' + escapeHTML(viewText) + '</span>' +
        '</div>' +
      '</a>' +
    '</div>';
  }

  // === Helpers ===
  function extractPrice(priceObj, curr) {
    if (!priceObj) return 0;
    if (typeof priceObj === 'number') return priceObj;
    return priceObj[curr] || priceObj['USD'] || 0;
  }

  function formatPrice(amount) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var formatted = parseFloat(amount).toFixed(2).replace(/\.00$/, '');
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, formatted)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(amount)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(amount)).replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  function escapeHTML(str) {
    var el = document.createElement('div');
    el.textContent = str || '';
    return el.innerHTML;
  }

  function escapeAttr(str) {
    return (str || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }
})();
